var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001ZM14.3722 7.99196C14.6185 7.71496 14.5935 7.29081 14.3165 7.04459C14.0395 6.79837 13.6154 6.82332 13.3691 7.10032L9.09877 11.9045L7.21436 9.78452C6.96814 9.50753 6.54398 9.48258 6.26698 9.7288C5.98999 9.97502 5.96504 10.3992 6.21126 10.6762L8.59722 13.3604C8.72456 13.5036 8.90709 13.5856 9.09877 13.5856C9.29045 13.5856 9.47297 13.5036 9.60032 13.3604L14.3722 7.99196Z",
    fill: "#008577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusPass);
export default __webpack_public_path__ + "static/media/status_pass.374e909c8859c3b836ec287dc5571ee5.svg";
export { ForwardRef as ReactComponent };